import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row mt-4" }
const _hoisted_2 = { class: "col-12 text-left" }
const _hoisted_3 = { class: "table-responsive" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("thead", { class: "thead-light" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "User"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "File Name"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Description"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Datetime"),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, "Action")
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_DataTable, {
          class: "table align-items-center table-flush ellipsis",
          options: _ctx.options,
          onInstance: _ctx.dtInstance,
          id: "management-list"
        }, {
          default: _withCtx(() => [
            _hoisted_4
          ]),
          _: 1
        }, 8, ["options", "onInstance"])
      ])
    ])
  ]))
}